import React from "react";
const NoOfTrainRun = () => {
  return <div> NoOfTrainRun</div>;
};
export default NoOfTrainRun;
